module.exports = __webpack_public_path__ + "static/media/Galdisa_lemon_chili_corn.7d111834.pdf";